import { IAccHinhThucNopTien } from "../../model/respone/category/IAccHinhThucNopTien";
import { apiClient } from "../apiClient";
export const HINHTHUCNOPTIEN_ENDPOINT = "hinh-thuc-nop-tien";
export const hinhThucNopTienApi = {
  SelectAll: () => apiClient.get(`${HINHTHUCNOPTIEN_ENDPOINT}`),
  Insert: (payload: IAccHinhThucNopTien) =>
    apiClient.post(`${HINHTHUCNOPTIEN_ENDPOINT}`, payload),
  Update: (payload: IAccHinhThucNopTien) =>
    apiClient.put(`${HINHTHUCNOPTIEN_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${HINHTHUCNOPTIEN_ENDPOINT}/${id}`),
};
